class GiftWrapToggle {
  constructor(el) {
    this.el = el;
    this.checkbox = el.querySelector('[data-giftwrap-checkbox]');
    this.wrapVariantId = el.dataset.wrapVariant;
    this.parentHandle = el.dataset.productHandle;
    this.checkbox.addEventListener('change', () => this.onChange());
  }

  async onChange() {
    if (!this.wrapVariantId) return;
    this.checkbox.disabled = true;
    try {
      if (this.checkbox.checked) {
        await this.addWrap();
      } else {
        await this.removeWrap();
      }
      this.refreshCart();
    } finally {
      this.checkbox.disabled = false;
    }
  }

  async addWrap() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(this.wrapVariantId),
          quantity: 1,
          properties: { '_wrap_for': this.parentHandle }
        }]
      })
    });
  }

  async removeWrap() {
    const cart = await fetch('/cart.js').then(r => r.json());
    const line = cart.items.find(
      i => i.properties && i.properties._wrap_for === this.parentHandle
    );
    if (line) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 })
      });
    }
  }

  refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    // If the cart doesn't update on screen, uncomment this:
    // window.location.reload();
  }
}

document.querySelectorAll('[data-giftwrap]').forEach(el => new GiftWrapToggle(el));